/**
 * Allow users to click on-click elements using the keyboard only
 */
const accessibility = () => {
	document.onkeydown = function( e ) {
		if ( e.keyCode === 13 ) {
			// Let native controls handle Enter to avoid double-click side effects.
			const activeElement = document.activeElement;
			if (!activeElement) return;

			const nativeInteractiveTags = ['BUTTON', 'A', 'INPUT', 'SELECT', 'TEXTAREA'];
			if (nativeInteractiveTags.includes(activeElement.tagName)) return;

			// The Enter/Return key
			activeElement.click();
		}
	};
};

export default accessibility;